'use client';

import Modal from "react-bootstrap/Modal";
import { FaCheck, FaInfoCircle, FaTimes } from "react-icons/fa";
import styles from "./TestResultModal.module.css";

export default function TestResultModal({ show, title, status, body, onClose }) {
    const isPassed = status === "passed" || status === "success";
    const isFailed = status === "failed";

    return (
        <Modal show={show} onHide={onClose} centered aria-labelledby="tools-result-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="tools-result-modal-title">
                    {isPassed && <FaCheck className="text-success me-2" aria-hidden="true" />}
                    {isFailed && <FaTimes className="text-danger me-2" aria-hidden="true" />}
                    {!isPassed && !isFailed && <FaInfoCircle className="text-info me-2" aria-hidden="true" />}
                    {title || "Test Result"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.body}>
                    {(isPassed || isFailed) && (
                        <p
                            className={`${styles.status} ${
                                isPassed ? styles.passed : styles.failed
                            }`}
                        >
                            {isPassed ? "PASSED" : "FAILED"}
                        </p>
                    )}
                    {typeof body === "string" ? <p className={styles.text}>{body}</p> : body}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}
